@if (showModal) {
  <div class="tw-modal tw-modal-open" data-theme="oab"
    role="dialog" aria-modal="true" aria-label="Alterar senha">
    <div class="tw-modal-box tw-bg-base-100 tw-max-w-md tw-p-0">
      <!-- Header -->
      <div class="tw-flex tw-items-start tw-justify-between tw-gap-4 tw-px-5 tw-py-4 tw-border-b tw-border-oab-line">
        <div class="tw-min-w-0">
          <h3 class="tw-text-lg tw-font-bold tw-text-oab-ink tw-m-0">Alterar senha</h3>
          <p class="tw-text-sm tw-text-oab-muted tw-mt-0.5">Defina uma nova senha de acesso.</p>
        </div>
        <button type="button" class="tw-btn tw-btn-ghost tw-btn-sm tw-btn-circle tw-shrink-0"
          aria-label="Fechar" (click)="closeModal()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <!-- Body -->
      <div class="tw-px-5 tw-py-4">
        <form [formGroup]="selecaoForm" novalidate class="tw-flex tw-flex-col tw-gap-3">
          <div>
            <label class="oab-field-label" for="password">Senha atual <span class="tw-text-error">*</span></label>
            <input id="password" type="password" formControlName="password"
              class="tw-input tw-input-bordered tw-input-sm tw-w-full"
              [class.tw-input-error]="selecaoForm.get('password')?.touched && selecaoForm.get('password')?.invalid">
            @if (selecaoForm.get('password')?.touched && selecaoForm.get('password')?.invalid) {
              <small class="tw-text-error tw-text-xs tw-mt-1 tw-block"
                >
                Senha atual é obrigatória.
              </small>
            }
          </div>
          <div>
            <label class="oab-field-label" for="newPassword">Nova senha <span class="tw-text-error">*</span></label>
            <input id="newPassword" type="password" formControlName="newPassword"
              class="tw-input tw-input-bordered tw-input-sm tw-w-full">
            @if (selecaoForm.get('newPassword')?.touched) {
              <div class="tw-mt-1">
                @if (selecaoForm.get('newPassword')?.hasError('required')) {
                  <small class="tw-text-error tw-text-xs tw-block">
                    Nova senha é obrigatória.
                  </small>
                }
                @if (selecaoForm.get('newPassword')?.value?.length < 6) {
                  <small class="tw-text-error tw-text-xs tw-block">
                    A senha deve ter no mínimo 6 caracteres.
                  </small>
                }
                @if (selecaoForm.get('newPassword')?.hasError('password')) {
                  <small class="tw-text-error tw-text-xs tw-block">
                    A senha não pode ser igual a 102030 ou 123456.
                  </small>
                }
                @if (selecaoForm.get('password')?.value === selecaoForm.get('newPassword')?.value) {
                  <small class="tw-text-error tw-text-xs tw-block"
                    >
                    A nova senha não pode ser igual à antiga.
                  </small>
                }
              </div>
            }
          </div>
          <div>
            <label class="oab-field-label" for="confNewPassword">Confirmar nova senha <span class="tw-text-error">*</span></label>
            <input id="confNewPassword" type="password" formControlName="confNewPassword"
              class="tw-input tw-input-bordered tw-input-sm tw-w-full">
            @if (selecaoForm.get('confNewPassword')?.touched) {
              <div class="tw-mt-1">
                @if (selecaoForm.get('confNewPassword')?.hasError('required')) {
                  <small class="tw-text-error tw-text-xs tw-block">
                    Confirmação da nova senha é obrigatória.
                  </small>
                }
                @if (selecaoForm.get('confNewPassword')?.value !== selecaoForm.get('newPassword')?.value) {
                  <small class="tw-text-error tw-text-xs tw-block"
                    >
                    A nova senha e a confirmação devem ser iguais.
                  </small>
                }
              </div>
            }
          </div>
        </form>
      </div>
      <!-- Footer -->
      <div class="tw-flex tw-justify-end tw-gap-2 tw-px-5 tw-py-4 tw-border-t tw-border-oab-line">
        <button type="button" class="tw-btn tw-btn-outline tw-btn-sm" (click)="closeModal()">Cancelar</button>
        <button type="button" class="tw-btn tw-btn-primary tw-btn-sm" (click)="atualizar()"
        [disabled]="selecaoForm.invalid ||
          selecaoForm.get('confNewPassword')?.value !== selecaoForm.get('newPassword')?.value ||
          selecaoForm.get('password')?.value === selecaoForm.get('newPassword')?.value">
          <i class="fa fa-check-circle" aria-hidden="true"></i> Atualizar
        </button>
      </div>
    </div>
    <div class="tw-modal-backdrop" (click)="closeModal()"></div>
  </div>
}
